//                                              [IMPORTS]
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import "../Admin2.css";

import Usercontactinfo from "./user_contactinfo";
import Userdata from "./user_data";
import Userfinances from "./user_finances";
import Usermessageus from "./user_messageus";
import Usersettings from "./user_settings";
import Userwebsite from "./user_website";

export default function User() {

  const navigate = useNavigate();

  //active tabs


    const [activeTab, setActiveTab] = useState("user_data");
    const [sidebarOpen, setSidebarOpen] = useState(false);


 //                                                          MEHANIZAM ZA PROVERU TOKENA I ULOGE KORISNIKA


  useEffect(() => {
    const token = localStorage.getItem("token");
    // ako nema JWT → nema ulaza
    if (!token) {
      navigate("/login");
    }
        try {
        const decoded = jwtDecode(token);
        // Proveravamo ulogu iz tokena
        if (!decoded.role || decoded.role !== "klijent") {
        navigate("/roleredirect"); // ako nije admin → Error stranica
        }
        } catch (err) {
          // token ne može da se dekodira
          navigate("/error");
        }
  }, [navigate]);




  return (

    <div className="min-vh-100 bg-dark text-white">
      <nav className="navbar navbar-dark bg-black px-4">
          <span className="navbar-brand fw-bold">
            <span className="text-primary">Alpha</span>PremiumSolutions 
          </span>
          <button className="hamburger d-lg-none" onClick={() => setSidebarOpen(true)}>☰</button>
          <button className="btn btn-outline-danger btn-sm" 
          onClick={() => { 
            localStorage.removeItem("token"); 
            navigate("/login");
          }}> Logout </button>
      </nav>

      {/* NAVBAR ZA STAVKE */}
      <div className="admin-layout">
      
      {/* SIDEBAR */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>

        <h5 className="sidebar-title">Dashboard</h5>

        {/* USERS */}
        <div className="sidebar-section">
          <p className="section-title">User</p>
          <button onClick={() => setActiveTab("user_data")}>My data</button>
          <button onClick={() => setActiveTab("user_website")}>My Websites</button>
          <button onClick={() => setActiveTab("user_finances")}>Subscriptions</button>
        </div>

        {/* WEBSITES */}
        <div className="sidebar-section">
          <p className="section-title">Contact</p>
          <button onClick={() => setActiveTab("user_messageus")}>Message us</button>
          <button onClick={() => setActiveTab("user_contactinfo")}>Contact Info</button>
        </div>

        <hr />

        <button className="settings-btn" onClick={() => setActiveTab("user_settings")}>
          Settings
        </button>

      </aside>

      {sidebarOpen && ( <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} /> )}

      {/* CONTENT */}
    <main className="admin-content">
        {activeTab === "user_data" && <Userdata />}
        {activeTab === "user_website" && <Userwebsite />}
        {activeTab === "user_finances" && <Userfinances />}
        {activeTab === "user_messageus" && <Usermessageus />}
        {activeTab === "user_contactinfo" && <Usercontactinfo />}
        {activeTab === "user_settings" && <Usersettings />}
    </main>

       </div>
    </div>
  );

}